/* eslint-disable import/no-named-as-default */
import React from "react";
import ChaloLoadingBar, {
  hideLoading,
  ImmutableLoadingBar,
  loadingBarMiddleware,
  loadingBarReducer,
  resetLoading,
  showLoading,
} from "./src";
import "./bar-loader.css";

export {
  hideLoading,
  ImmutableLoadingBar,
  loadingBarMiddleware,
  loadingBarReducer,
  resetLoading,
  showLoading,
};
export class BarLoader extends React.PureComponent {
  render() {
    const { scope } = this.props;
    return (
      <div>
        <ChaloLoadingBar
          scope={scope}
          className="header-loader"
          updateTime={100}
          maxProgress={95}
          progressIncrease={10}
          showFastActions
        />
      </div>
    );
  }
}
